import * as types from '../../contactUs/constants/ActionTypes';

const initialState = {
  display: false,
  opened: false,
  q: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.CLOSE_MOBILE_FILTER:
      return { ...state, display: action.payload, opened: false };
    case types.OPEN_MOBILE_FILTER:
      return { ...state, display: action.payload, opened: true };
    case types.REQUEST_ARTICLE_SEARCH:
      return { ...state, display: false };
    case types.RECEIVE_ARTICLE_SEARCH_RESPONSE: {
      const queryNotUpdate = state.opened && state.q === action.payload.q;
      return {
        ...state,
        q: action.payload.q,
        display: false,
        opened: queryNotUpdate,
      };
    }
    case types.RECEIVE_ARTICLE_SEARCH_ERROR:
      return {
        ...state,
        q: action.payload.q,
        display: false,
        opened: false,
      };
    default:
      return state;
  }
}
